<template>
    <div class="user-payment-tab" ref="tab">
      <div id="action-bar">
        <div class="remove-subscription-bar">
          <el-select v-model="selectedSubscription" placeholder="Select subscribtion">
            <el-option v-for="plan in userPaymentsMeta.subscriptions"
              :key="plan.subscription_id"
              :label="plan.plan_name"
              :value="plan.subscription_id">
            </el-option>
          </el-select>
          <el-popconfirm
            @onConfirm="handleDeactivate()"
            confirmButtonType="danger"
            confirmButtonText='Deactivate'
            cancelButtonText='Cancel'
            icon="mdi mdi-close-circle-outline"
            iconColor="red"
            title="This action will remove credits for chosen subscription and remove all recurring tasks! Are you sure to deactivate this subscription?"
          >
            <el-button slot="reference" type="danger" icon="mdi mdi-close-circle-outline" plain :disabled="!selectedSubscription">Deactivate</el-button>
          </el-popconfirm>
        </div>
        <div class="add-payment-bar">
            <el-select v-model="selectData.value" placeholder="Add plan">
              <el-option
                v-for="(title, id) in selectData.options"
                :key="id"
                :label="title"
                :value="id">
              </el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-plus" @click="handleClick">Add</el-button>
        </div>
      </div>

      <div
          v-if="paymentsList && paymentsList.length > 0">
        <el-form
          v-for="(payment, indx) in paymentsList"
          status-icon
          label-width="150px"
          :key="`${indx}_${payment.subscription_id}`"
        >
        <el-form-item :label="payment.plan_name"  >
          <el-input
            type="number"
            class="payment-form-input"
            v-model="paymentsList[indx].value">
            <el-button
            slot="append"
            type="primary"
            class="payment-form-submit"
            :loading="false"
            @click="onSubmit(payment.subscription_id, indx)" >Save </el-button>
            </el-input>
        </el-form-item>

      </el-form>
      </div>

        <div v-else>
          <h5>No avalieble plans</h5>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import router from '../../../router/'
  import request from '../../../servises/request';
  import html2canvas from 'html2canvas';

  export default {
    name: 'UserPayment',
    props: {
      isScreenProcess: Boolean,
      isPaymentInfoScreenProcess: Boolean,
      screenshotPage: HTMLDivElement
    },
    data () {
      return {
        paymentsList: [],
        selectedSubscription: null,
        selectData: {
          options: {},
          value: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        userPayments: 'users/userPayments',
        userPaymentsMeta: 'users/userPaymentsMeta',
      }),
    },
    watch: {
      userPayments: function (val, oldval) {
        let copy = []
        if (val && val.length > 0) {
          copy = [...val]
        }
        this.paymentsList = copy
      },
      isPaymentInfoScreenProcess: function (val, oldVal) {
          if (val) {
            setTimeout(() => {
                this.createCanvas();
            }, 4000)

          }
      }
    },
   mounted () {

      this.$store.dispatch('users/getUserPayments', this.$route.params.id)
      this.getPlanList();
      if (this.isScreenProcess) {
        this.updateUserPaymentList().then(response => {
          this.createCanvas()
        }).catch(err => console.log(err)
        );
      }
    },
    methods: {
      async createCanvas () {
        this.screenshotPage.style.overflow = 'visible';
        this.screenshotPage.style.height = 'auto';
        const canvas = await html2canvas(this.screenshotPage, {
          scrollX: 0,
          scrollY: -window.scrollY,
          width: this.screenshotPage.offsetWidth,
          height: this.screenshotPage.scrollHeight,
        });
        const imgURL = {
          url: canvas.toDataURL('image/png'),
          name: 'Payment Info',
        };

        this.$emit('addNewImage', imgURL);
        this.$emit('togglePaymentHistory');
        this.$emit('triggerNextTab', 'paymentHistory');

      },

      updateUserPaymentList() {
        let userScans =  this.$store.dispatch('users/getUserPayments', this.$route.params.id)
            .then(response => Promise.resolve(response))
        return userScans;
      },

      handleClick: async function() {
       try {
          const resp = await request({
            url: `/user/${this.$route.params.id}/plan/${this.selectData.value}`,
            method: 'POST',
            data: {}
          })
          this.$store.dispatch('users/getUserPayments', this.$route.params.id)
          Message({
            message: 'Plan was added',
            type: 'success',
            duration: 3 * 1000
          })

        } catch(err) {
          Message({
            message: 'Plan is not added',
            type: 'error',
            duration: 5 * 1000
         })
        }
      },
      handleDeactivate: async function() {
       try {
          const resp = await request({
            url: `/user/subscription/${this.selectedSubscription}/deactivate`,
            method: 'POST',
            data: {}
          })
          window.location.reload();

        } catch(err) {
          Message({
            message: 'Error deactivate subscription #'+this.selectedSubscription,
            type: 'error',
            duration: 5 * 1000
         })
        }
      },
      onSubmit: async function(id, indx) {
        const value = this.paymentsList[indx].value
        try {
          const resp = await request({
            url: `/user/subscription/${id}`,
            method: 'PATCH',
            data: {
              value
            }
          })
          Message({
            message: 'Value is saved',
            type: 'success',
            duration: 3 * 1000
          })

        } catch(err) {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000
         })
        }


      },
      getPlanList: async function(id, indx) {
        try {
          const resp = await request({
            url: `/plan/available`,
            method: 'GET'
          })
          this.selectData.options = resp

        } catch(err) {
          Message({
            message: 'Plans are not recieved',
            type: 'error',
            duration: 5 * 1000
         })
        }
      }
    },

  }
</script>

<style lang="scss">
    #action-bar{
      display: flex;
      justify-content: space-between;
    }
    .add-payment-bar, .remove-subscription-bar {
      padding: 10px 0 20px;
      justify-content: flex-end;
      display: flex;
      .el-button {
        margin-left: 15px;
      }
    }
    .payment-form-input .el-input__inner{
      padding-right: 0;
    }
    .el-button.payment-form-submit.el-button--primary{
      background-color: #5f8fdf;
      color: #fff;
      margin-top: 0;
      margin-bottom: 0;
    }
</style>
